import Form, {
  formCreate,
} from '../../../../../../../found/components/form';
import request from '../../../../../../../found/utils/request';
import orgName from './selectCompany.vue';

formCreate.component('orgName', orgName);
export default {
  extends: Form,
  components: {
    formCreate: formCreate.$form(),
  },
  data() {
    return {
      rule: [],
      formFunctionCode: 'main_form',
    };
  },
  async created() {
    await this.getFormRule('main_form');
  },
  methods: {
    // 设置规则
    setRule(item) {
      if (item.field === 'orgName') {
        item.props = {
          ...item.props,
          getValue: (field) => this.getFieldValue(field),
          title: item.title,
        };
        item.on = {
          ...item.on,
          change: (e) => {
            this.setValue({
              orgName: e.orgName,
              orgCode: e.orgCode,
            });
          },
        };
      }
      return item;
    },
    // 渲染完成后执行
    formComplete() {
      const {
        code,
        row,
      } = this.formConfig;
      if (code !== 'add') {
        request.get('/cps/v1/terminalNetworkConstruction/findById', {
          id: row.id,
        }).then((res) => {
          if (res.success) {
            console.log(res, 'res');
            const {
              result,
            } = res;
            this.setValue({
              ...result,
            });
          }
        });
      }
    },
    submit() {
      const formData = this.getFormData();
      if (formData) {
        const params = {
          ...formData,
        };
        let url = '';
        if (this.formConfig.code === 'add') {
          url = '/cps/v1/terminalNetworkConstruction/create';
        } else {
          params.id = this.formConfig.row.id;
          url = '/cps/v1/terminalNetworkConstruction/update';
        }
        request.post(url, {
          ...params,
        }).then((res) => {
          if (res.success) {
            this.$message.success('操作成功');
            this.$emit('onClose');
            this.$emit('onGetList');
          }
        });
      }
    },
  },
};
